

<template>
    <div class="payment-setting-box">
        <a-tabs v-model="tabIndex" @change="tabChange" tab-position="top">
            <a-tab-pane :key="1" :tab="$t('hotel.invoice_cn' /* 中宾发票配置 */)"></a-tab-pane>
            <a-tab-pane :key="2" :tab="$t('hotel.invoice_en' /* 外宾发票配置 */)"></a-tab-pane>
        </a-tabs>
        <a-table :rowKey="record => record.channel_id" :pagination="false" :columns="columns" :data-source="onLineDataList" class="mt10" :loading="loading" :scroll="{ x: 500 }">
            <!-- <span slot="name" slot-scope="text, record">
        <a-avatar :src="record.pay_ico" :size="30" style="margin-right: 10px" />
        {{ text }}
      </span> -->
            <!-- <span slot="status" slot-scope="text, record">
        <a-switch
          checked-children="显示"
          un-checked-children="隐藏"
          :checked="record.status == 1"
          @change="handleChangeStatus(record)"
        />
      </span> -->
            <span slot="action" slot-scope="text, record">
                <a-button @click="handleShowGoodsData(record, 'invoiceParams')" type="link">{{ $t('hotel.invoice_params' /* 发票参数配置 */) }}</a-button>
                <a-button @click="handleShowGoodsData(record, 'invoiceProject')" type="link">{{ $t('hotel.service' /* 服务项目 */) }}</a-button>
                <a-button @click="handleShowGoodsData(record, 'invoiceApi')" type="link">{{ $t('hotel.invoice_api' /* 发票接口配置 */) }}</a-button>
            </span>
        </a-table>

        <invoice-params ref="invoiceParams"></invoice-params>
        <invoice-project ref="invoiceProject"></invoice-project>
        <invoice-api ref="invoiceApi"></invoice-api>
    </div>
</template>

<script>
import invoiceProject from './components/invoice-config/invoice-project.vue';
import invoiceParams from './components/invoice-config/invoice-params.vue';
import invoiceApi from './components/invoice-config/invoice-api.vue';
export default {
    name: 'HotelType',
    components: {
        invoiceParams,
        invoiceProject,
        invoiceApi
    },
    data() {
        return {
            tabIndex: 1,
            onLineDataList: [],
            loading: false,
            dataInfo: {},
            visible: false,
            columns: [
                {
                    title: this.$t('hotel.channel_category_name' /* 渠道分类名称 */),
                    dataIndex: 'channel_name'
                },

                {
                    title: this.$t('web.create_time' /* 创建时间 */),
                    dataIndex: 'create_time',
                    align: 'center'
                },
                {
                    title: this.$t('web.actions' /* 操作 */),
                    dataIndex: 'action',
                    align: 'center',
                    scopedSlots: { customRender: 'action' }
                }
            ]
        };
    },
    created() {
        this.getDataList();
    },
    methods: {
        tabChange(val) {
            let data = {
                language: val == 1 ? 'cn' : 'en'
            };
            this.$request.get({ url: 'geyInvoiceChannelList', data }).then(res => {
                this.onLineDataList = res.data.data;
            });
        },
        getDataList() {
            let data = {
                language: 'cn'
            };
            this.$request.get({ url: 'geyInvoiceChannelList', data }).then(res => {
                this.onLineDataList = res.data.data;
            });
        },
        handleChangeStatus(record) {
            let data = {
                channel_id: record.channel_id,
                status: record.status == 1 ? 0 : 1
            };
            // this.$request.post({ url: "setChannelStatus", data }).then((res) => {
            //   this.getDataList();
            //   this.$message.success("修改成功");
            // });
        },

        handleShowGoodsData(record, type) {
            if (type === 'invoiceParams') {
                record['language'] = this.tabIndex == 1 ? 'cn' : 'en';
            }
            this.$refs[type].show(record);
        },
        handleCancel() {
            this.dataInfo = {};
            this.visible = false;
        },
        handleOk() {
            this.dataInfo = {};
            this.getDataList();
            this.visible = false;
        }
    }
};
</script>

<style scoped lang="less">
.payment-setting-box {
    /deep/.ant-table-thead > tr > th,
    /deep/.ant-table-tbody > tr > td {
        padding: 10px 15px;
    }
}
</style>